import React from 'react'

import YouTube from 'react-youtube'

import { SlideinWrap, SlideinItem } from 'src/components/slidein/index'

import * as styles from './movie.module.scss'


const Movie = ({ vid, caption }) => {

    const options = {
        playerVars: {
            rel: 0,
            iv_load_policy: 3,
            modestbranding: 1
        }
    }

    return (
        <SlideinWrap>
            <SlideinItem className={styles.movie}>
                <YouTube videoId={vid} opts={options}></YouTube>
            </SlideinItem>
            <SlideinItem delay={300} className={styles.caption}>
                {caption}
            </SlideinItem>
        </SlideinWrap>
    )
}

export default Movie